module.exports = __webpack_public_path__ + "img/制御工学7_3_2.71c6a885.png";